export default __webpack_public_path__ + "static/media/marketing.956e8ff1.png";